import type { TourStep } from '@/components/ui/Tour';
import { PROGRAM_CREATE_TOUR_STEP_IDS } from '../tour-constants';
import { TourStepContent } from './StepContent';

/** New-program drawer — pathway basics, skills, and save. */
export const programCreateTourSteps: TourStep[] = [
  {
    content: (
      <TourStepContent
        title="Create a program"
        description="Development programs define pathways and target skills. Link lessons to a program so coaches can track player progress."
      />
    ),
    selectorId: PROGRAM_CREATE_TOUR_STEP_IDS.DRAWER,
    position: 'left',
  },
  {
    content: (
      <TourStepContent
        title="Program basics"
        description="Give the stage a clear name, pick the sport, and add a short description families and coaches will see."
      />
    ),
    selectorId: PROGRAM_CREATE_TOUR_STEP_IDS.DETAILS,
    position: 'bottom',
  },
  {
    content: (
      <TourStepContent
        title="Pathway links"
        description="Choose which program this stage follows, set goals, and enable invitation-only when enrolment should be selective."
      />
    ),
    selectorId: PROGRAM_CREATE_TOUR_STEP_IDS.PATHWAY,
    position: 'bottom',
  },
  {
    content: (
      <TourStepContent
        title="Target skills"
        description="Add the skills coaches will tick off as students progress. You can edit these any time after saving."
      />
    ),
    selectorId: PROGRAM_CREATE_TOUR_STEP_IDS.SKILLS,
    position: 'top',
  },
  {
    content: (
      <TourStepContent
        title="Save the program"
        description="Create the program when you are ready, then link lessons or import more stages from a template."
      />
    ),
    selectorId: PROGRAM_CREATE_TOUR_STEP_IDS.SUBMIT,
    position: 'top',
  },
];
